import { render, staticRenderFns } from "./BaseButtonLight.vue?vue&type=template&id=5808bab6&scoped=true"
import script from "./BaseButtonLight.vue?vue&type=script&lang=js"
export * from "./BaseButtonLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5808bab6",
  null
  
)

export default component.exports